import produce from 'immer';

const INITIAL_STATE = {
  property: {},
};

export default function auth(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@property/OPEN_PROPERTY': {
        break;
      }
      case '@property/OPEN_PROPERTY_SUCCESS': {
        draft.property = action.payload.property.property;
        break;
      }
      default:
        break;
    }
  });
}
